export default __webpack_public_path__ + "static/media/express.bd60c4de.png";